/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_created", "_items"] }] */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { SMALL } from '../../utils/withWidth';
import actions from '../../state/actions';
import WorkorderCard from './WorkorderCard';
import LoadMore from '../../components/LoadMore';
import Screen from '../../components/Screen';
import TopBar from './WorkordersTopBar';
import { localize } from '../../i18n';

import './Workorders.css';

class Workorders extends Component {
  constructor(props) {
    super(props);
    this.didProcessRequest = false;
    this.state = {
      loadingMore: false,
    };
  }

  componentWillMount() {
    this.props.addRefreshFunction((isManual) => {
      this.props.processRequest(!isManual);
    });
    if (this.didProcessRequest === false) {
      this.didProcessRequest = true;
      this.props.processRequest(false);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.didProcessRequest === false) {
      this.didProcessRequest = true;
      this.props.processRequest(false);
    }
    if (nextProps.actionType === 'API_READ' && nextProps.lastAction.configType === 'workordersList') {
      this.setState({
        loadingMore: false,
      });
    }
  }

  componentWillUnmount() {
    this.props.removeRefreshFunction();
  }

  render() {
    const {
      workOrders,
      channels,
      workorderConfigs,
      nextAction,
      processMoreRequests,
      width,
      children,
      params,
    } = this.props;

    let subHeader = null;
    let workOrdersList = '';
    let loadMore = null;
    let childComponent = null;

    if (workOrders.loaded === true) {
      let viewTypeClass = 'list_view';

      if (width > SMALL) {
        viewTypeClass = 'grid_view';
      }
      const listGridClasses = `uk-grid uk-grid-medium uk-grid-width-small-1-1 uk-grid-width-medium-1-2 uk-grid-width-large-1-2 ${viewTypeClass}`;

      const currentWorkordersList = workOrders.data.map((workorder) => {
        const workorderConfig = _.find(workorderConfigs, { work_order_name: workorder.type }) || {};
        let dashboardColor = '#fff';
        if (channels.length > 0) {
          dashboardColor = (_.find(channels, { name: workorder.channel }) || {}).dashboard_color;
        }

        return (
          <WorkorderCard
            key={workorder._id}
            workorderConfig={workorderConfig}
            workorder={Object.assign({}, workorder, {
              dashboardColor,
              icon: workorderConfig.icon,
            })}
          />
        );
      });
      subHeader = (
        <h4 className="heading_a">{this.props.t('Current ({workOrdersDataLength})', { workOrdersDataLength: workOrders.data.length })}</h4>
      );
      workOrdersList = (
        <div className={listGridClasses}>
          {currentWorkordersList}
        </div>
      );

      if (nextAction !== null) {
        loadMore = (
          <LoadMore
            loading={this.state.loadingMore}
            onLoadMore={() => {
              this.setState({
                loadingMore: true,
              }, () => {
                processMoreRequests();
              });
            }}
            fillPage
            scrollBased
          />
        );
      }
    }
    if (children) {
      childComponent = React.cloneElement(children, {
        params,
      });
    }

    return (
      <Screen title={this.props.t('Work Orders')} helpUrl="#wo">
        <TopBar />
        <div className="Workorders" style={{ paddingTop: '40px' }}>
          {subHeader}
          {workOrdersList}
          {loadMore}
          {childComponent}
          <div className="md-fab-wrapper">
            <Link to="/access/workorders/create" className="md-fab md-fab-accent">
              <i className="material-icons">&#xE145;</i>
            </Link>
          </div>
        </div>
      </Screen>
    );
  }
}

Workorders.propTypes = {
  // eslint-disable-next-line
  actionType: PropTypes.string,
  workOrders: PropTypes.shape({
    loaded: PropTypes.bool,
    data: PropTypes.array,
  }),
  channels: PropTypes.arrayOf(PropTypes.object),
  workorderConfigs: PropTypes.arrayOf(PropTypes.object),
  addRefreshFunction: PropTypes.func,
  removeRefreshFunction: PropTypes.func,
  processRequest: PropTypes.func,
  processMoreRequests: PropTypes.func,
  children: PropTypes.element,
  params: PropTypes.shape(Object),
  width: PropTypes.number,
  nextAction: PropTypes.shape(Object),
  // eslint-disable-next-line
  lastAction: PropTypes.shape(Object),
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  let nextAction = null;
  const actionType = state.action.type;
  const lastAction = state.api.lastAction;
  let locations = [];
  let reservations = [];
  let totalLocations = 0;

  const {
    session: {
      channels,
    },
    layout: {
      size: width,
    },
  } = state;

  const workOrders = {
    data: [],
    loaded: false,
  };
  let workorderConfigs = [];

  if (state.ticket.work_order) {
    workOrders.loaded = true;
    workOrders.data = state.ticket.work_order._items;
  }

  if (state.ticket.work_order_config) {
    workorderConfigs = state.ticket.work_order_config._items;
  }
  if (state.api.location) {
    locations = state.api.location.data;
    totalLocations = locations.length;
  }

  if (state.api.reservation) {
    reservations = state.api.reservation.data;
  }

  if (state.api.nextAction.workordersList) {
    nextAction = state.api.nextAction.workordersList;
  }

  return {
    actionType,
    locations,
    workOrders,
    workorderConfigs,
    reservations,
    totalLocations,
    nextAction,
    lastAction,
    width,
    channels: channels.filter(ch => ch.type === 'work_order'),
  };
};

const mapDispatchToProps = dispatch => ({
  addRefreshFunction(func) {
    dispatch(actions.addRefreshFunction('work-orders', func));
  },
  removeRefreshFunction() {
    dispatch(actions.removeRefreshFunction('work-orders'));
  },
  processRequest(noLoader) {
    console.log(actions);
    dispatch(actions.retrieveWorkorderConfigs(null, noLoader));
    dispatch(actions.retrieveWorkorders(null, noLoader));
  },
  processMoreRequests() {
    dispatch(actions.retrieveMoreWorkorders());
  },
});

export default localize(connect(mapStateToProps, mapDispatchToProps)(Workorders));



// WEBPACK FOOTER //
// ./src/views/workorders/Workorders.js